import { Domicilio, Persona } from "../../comun/model/poliza.model";

export interface DatosPersonalesConfig extends BasicConfig{
    persona?: Persona;
    mostrarDocumento?: boolean;
    mostrarNombre?: boolean;
    mostrarFechaNacimiento?: boolean;
    mostrarSexo?: boolean;
}

export interface DatosDomicilioConfig extends BasicConfig{
    domicilio?: Domicilio;
    mostrarVia?: boolean;
    mostrarLocalidad?: boolean;
    mostrarProvincia?: boolean;
}

export interface DatosAdicionalesConfig extends BasicConfig{
    mostrarIdiomas?: boolean;
    mostrarFechaEfecto?: boolean;
    mostrarFechaVencimiento?: boolean;
    mostrarFraccionamiento?: boolean;
}

export interface BasicConfig {
    modoEdicion?: ModoEdicion;
    rol?: string;
}

export enum ModoEdicion {
    SI = 'SI',
    NO = 'NO',
    VALORES = 'VALORES'
}
